import type { PricingTierFormValue } from "./schemas"

import type { Location, PriceChangeTier } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const toPricingTierFormValues = (tiers: PriceChangeTier[]): PricingTierFormValue[] =>
  tiers.map((tier) => ({
    qty: tier.qty,
    uom: tier.uomId,
    price: tier.price.toString(),
  }))

export const locationsToOptions = (locations: Location[]): Option<string>[] =>
  locations.map((location) => ({
    label: location.name ?? location.locationId,
    value: location.locationId,
  }))
